/**
 * Fonction utilitaire pour calculer une couleur à partir d'un hash du nom d'un tag
 * @param tagName - Le nom du tag
 * @returns Une couleur hexadécimale (ex: "#3B82F6")
 */
export const getTagColor = (tagName: string): string => {
  // Fonction de hash simple basée sur le nom du tag
  let hash = 0;
  for (let i = 0; i < tagName.length; i++) {
    hash = tagName.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Générer une couleur HSL avec une saturation et luminosité fixes pour avoir des couleurs vives
  // Utiliser le hash pour déterminer la teinte (hue) entre 0 et 360
  const hue = Math.abs(hash) % 360;
  
  // Utiliser des valeurs de saturation et luminosité qui donnent des couleurs vives mais lisibles
  const saturation = 60 + (Math.abs(hash) % 20); // Entre 60% et 80%
  const lightness = 45 + (Math.abs(hash) % 15); // Entre 45% et 60%

  // Convertir HSL en RGB puis en hexadécimal
  const h = hue / 360;
  const s = saturation / 100;
  const l = lightness / 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h * 6) % 2) - 1));
  const m = l - c / 2;

  let r = 0, g = 0, b = 0;

  if (h < 1 / 6) {
    r = c;
    g = x;
    b = 0;
  } else if (h < 2 / 6) {
    r = x;
    g = c;
    b = 0;
  } else if (h < 3 / 6) {
    r = 0;
    g = c;
    b = x;
  } else if (h < 4 / 6) {
    r = 0;
    g = x;
    b = c;
  } else if (h < 5 / 6) {
    r = x;
    g = 0;
    b = c;
  } else {
    r = c;
    g = 0;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

